import { useEffect, useRef } from 'react';
import animationData from './animationData.json';

const AppLoader = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    let anim: { destroy: () => void } | null = null;

    import('lottie-web').then(({ default: lottie }) => {
      if (!containerRef.current) return;
      anim = lottie.loadAnimation({
        container: containerRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
    });

    return () => { anim?.destroy(); };
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen w-full px-6 text-center bg-[#6D57BC]">
      {/* En un celular (< 500px) la animación se achica al ancho de la pantalla; en pantallas anchas queda en 500x500. */}
      <div ref={containerRef} style={{ height: 'min(500px, 100vw)', width: 'min(500px, 100vw)' }} />
      <p className="text-xl font-bold text-white pb-5" style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}>
        Preparando plataforma...
      </p>
      <p className="text-xl font-normal text-white" style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}>
        En unos segundos podrás consultar por tus terapias y sesiones
      </p>
    </div>
  );
};

export default AppLoader;
